import BaseClient from './client';

export const MedicationPath = Object.freeze({
    MEDICATIONS: 'v1/medications',
});

const pathId = (value, name) => {
    if (value === undefined || value === null || value === '') {
        throw new TypeError(`${name} is required`);
    }
    return encodeURIComponent(String(value));
};

const requiredText = (value, name) => {
    const result = String(value ?? '').trim();
    if (!result) throw new TypeError(`${name} is required`);
    return result;
};

/**
 * Prescription API grouped by workflow:
 * prescriptions, entries, templates, special templates, and printing.
 *
 * Authentication is inherited from BaseClient and is enabled by default.
 */
export class MedicationsService extends BaseClient {
    // -------------------------------------------------------------------------
    //  Medications workflow
    // -------------------------------------------------------------------------

    /**
     * search for medications directly from server
     * @params Object queries a key-value object define params
     * @returns {Promise} request with the response body as an object.
     */
    async searchMedications(queries) {
        return await this.withAuth()
            .get(MedicationPath.MEDICATIONS, { query: queries })
            .send()
    }


    /**
     * fetch all medications directly from server
     * @returns {Promise} request with the response body as an object.
     */
    fetchAllMedications() {
        return this.withAuth()
            .get(MedicationPath.MEDICATIONS)
    }

}

// Ready-to-use shared instance. Importing it does not alter any legacy caller.
export const medicationsService = new MedicationsService();

export default MedicationsService;
